import React from 'react'
import { useHistory } from 'react-router-dom'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'

// "APP 랭킹경품"은 경품 규칙과 지급 내역 두 화면을 탭으로 오간다.
const TABS = [
    { value: 'rules', label: '경품 규칙', pathname: '/appRankingBanners' },
    { value: 'grants', label: '지급 내역', pathname: '/appRankingRewards' },
]

export default function AppRankingRewardTabs({ current = 'rules', disabled = false }) {
    const history = useHistory()

    const handleChange = (_event, value) => {
        if (disabled || value === current) {
            return
        }

        const target = TABS.find((tab) => tab.value === value)

        if (target) {
            history.push(target.pathname)
        }
    }

    return (
        <Tabs value={current} onChange={handleChange} sx={{ mb: 1, borderBottom: '1px solid rgba(148, 163, 184, 0.3)' }}>
            {TABS.map((tab) => (
                <Tab key={tab.value} value={tab.value} label={tab.label} disabled={disabled && tab.value !== current} />
            ))}
        </Tabs>
    )
}
